import React, { Fragment } from 'react'
import { withRouter } from 'react-router-dom'

// components
import BotonBack from '../Utiles/BotonBack'
import Subtitulo from '../Utiles/Subtitulo'

// services

// icons
import {
    faEdit,
    faLayerGroup,
    faPercent,
} from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

// formik
import Header from '../Header/Header'
import useDepartment from './hooks/useDepartment'

function EditDepartamento({ history, location }) {
    const { formikEdit } = useDepartment(history, location)
    return (
        <Fragment>
            <Header />
            <div className="container-fluid mt-3">
                <div className="alert alert-dismissible alert-secondary d-flex justify-content-between">
                    <BotonBack />
                    <Subtitulo icon={faLayerGroup} title={'Departamentos'} />
                </div>

                <div className="bg-gris p-4">
                    <form onSubmit={formikEdit.handleSubmit}>
                        <div className="form-row">
                            <div className="form-group col-md-6">
                                <label htmlFor="inputNombre">Nombre</label>
                                <div className="input-group-prepend">
                                    <span
                                        className="input-group-text"
                                        id="inputGroupPrepend"
                                    >
                                        <FontAwesomeIcon icon={faLayerGroup} />
                                    </span>
                                    <input
                                        type="text"
                                        id="inputNombre"
                                        name="nombre"
                                        className="form-control"
                                        placeholder="Ej. Lacteos, Gaseosas..."
                                        value={formikEdit.values.nombre}
                                        onChange={formikEdit.handleChange}
                                        onBlur={formikEdit.handleChange}
                                    />
                                </div>
                                {formikEdit.touched.nombre &&
                                formikEdit.errors.nombre ? (
                                    <small className="form-text text-danger">
                                        {formikEdit.errors.nombre}
                                    </small>
                                ) : null}
                            </div>
                            <div className="form-group col-md-6">
                                <label htmlFor="inputIva">Tasa IVA</label>
                                <div className="input-group-prepend">
                                    <span
                                        className="input-group-text"
                                        id="inputGroupPrepend"
                                    >
                                        <FontAwesomeIcon icon={faPercent} />
                                    </span>
                                    <input
                                        type="number"
                                        step="any"
                                        min="0"
                                        id="inputIva"
                                        name="tasaIva"
                                        className="form-control"
                                        placeholder="Ej. %21.0"
                                        value={formikEdit.values.tasaIva}
                                        onChange={formikEdit.handleChange}
                                        onBlur={formikEdit.handleChange}
                                    />
                                </div>
                                {formikEdit.touched.tasaIva &&
                                formikEdit.errors.tasaIva ? (
                                    <small className="form-text text-danger">
                                        {formikEdit.errors.tasaIva}
                                    </small>
                                ) : null}
                            </div>
                        </div>

                        <div className="text-center">
                            <button
                                type="submit"
                                className="btn btn-outline-danger"
                            >
                                <FontAwesomeIcon icon={faEdit} /> Editar
                                Departamento
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </Fragment>
    )
}

export default withRouter(EditDepartamento)
